// extracted by mini-css-extract-plugin
module.exports = {"DraggableCard":"yb_a"};